import { ReactNode } from 'react'

type RenderIfProps = {
  children: ReactNode // The content to render if the condition is true
  condition: boolean // The boolean condition
  fallback?: ReactNode // Optional content to render if the condition is false
}

const RenderIf = ({ children, condition, fallback }: RenderIfProps) => {
  return condition ? children : fallback || null
}

export default RenderIf
